<template>
  <master-layout v-bind:pageTitle="currentUser.username">
    <div class="center-feed">
      <ion-grid>
        <ion-row>
          <ion-col><ion-button expand="block" v-bind:fill="myTunesButton" @click="changeTab('myTunes')">{{ $t('myTunes') }}</ion-button></ion-col>
          <ion-col><ion-button expand="block" v-bind:fill="toLearnButton" @click="changeTab('toLearn')">{{ $t('toLearn') }}</ion-button></ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <userTunes-list v-if="myTunesButton === 'solid'" exclUnrated="true" :toLearn="false" :key="componentKey + '_myTunes'"/>
    <userTunes-list v-if="toLearnButton === 'solid'" exclUnrated="true" :toLearn="true" :key="componentKey + '_toLearn'"/>
  </master-layout>
</template>
  
<script>
  import UserTunesList from "@/components/UserTunesList.vue";
  import { IonButton, IonGrid, IonRow, IonCol } from '@ionic/vue';

  export default {
    name: 'Profile',
    components: {
      UserTunesList,
      IonButton,
      IonGrid,
      IonRow,
      IonCol
    },
    data() {
      return {
        componentKey: 0,
        myTunesButton: 'solid',
        toLearnButton: 'outline',
      };
    },
    computed: {
      currentUser() {
        if(this.$store.state.auth.user != null) {
          return this.$store.state.auth.user;
        }
        else {
          return {username: ""}
        }
      }
    },
    methods: {
      changeTab(tab) {
        if (tab === 'myTunes') {
          this.myTunesButton = 'solid';
          this.toLearnButton = 'outline';
        } else if (tab === 'toLearn') {
          this.toLearnButton = 'solid';
          this.myTunesButton = 'outline';
        }
      },
    },
    watch: {
      $route(to) {
        // Increment the key to force re-rendering of UserTunesList
        if(to.path === '/profile') {
          console.log("in watch");
          this.componentKey += 1;
        }
      },
    },
    mounted() {
      if (!this.currentUser) {
        this.$router.push('/login');
      }
      /*else {
        console.log(this.currentUser)
      } */
    }
  };
</script>